// @flow
import client from '../../client'

// API Endpoints
export const CAPTURE_EMAIL_ENDPOINT = '/engage/'

export type CaptureEmail = {
  id?: number,
  email: string,
  url: string,
  provider_name?: string,
  name?: string,
  company_name?: string,
  page_type?: string,
  session_id?: string,
  phone_number?: string,
  partner?: string,
  campaign?: string,
}

/**
 * Captures users email upon leaving booking page
 * @param {Object} data User information
 * @param {string} data.email User's email
 * @param {string} data.url User's URL
 * @param {string} data.provider_name Provider name
 * @param {string} [data.name] User's name
 * @param {string} [data.company_name] User's company name
 * @param {string} [data.page_type] User's page type
 * @param {string} [data.session_id] User's session ID
 * @param {string} [data.phone_number] User's phone number
 * @param {string} [data.partner] Partner
 * @return {Promise|Error} A resolved Promise with the user's email capture information or Rejected with an Error
 */
export const captureEmail = (data: CaptureEmail): Promise<CaptureEmail> => {
  const defaultValues = {
    campaign: 5,
  }

  const query = { ...defaultValues, ...data }

  return client.post(CAPTURE_EMAIL_ENDPOINT, { body: query })
}

export default captureEmail
